import React, {useState} from 'react';
import FrameworkCreationView from "../../views/ver_24.10/FrameWorks/FrameworkCreation.view";
import {REGIONS} from "../../utils/META/cat_101";
import {ORG_TYPES} from "../../utils/META/cat_102";
import {SECTORS} from "../../utils/META/cat_103";
import {HIST_DURATIONS} from "../../utils/META/cat_104";
import {PROGRAM_TARGETS} from "../../utils/META/cat_108";
import {TARGET_AGE} from "../../utils/META/cat_109";

const FrameworkCreationPage = () => {
    const dummyChat = [
        { id: 1, role: "bot", text: "We will ask you a series of questions to build a framework that is specifically tailored to your needs.", options: ["Next"] },
        { id: 2, role: "bot", text: "Are you representing a national government ministry or agency?", options: ["Yes", "No"] },
        {
            id: 3,
            role: "bot",
            text: "Please fill out the following information about your organization.",
            type: "form",
            fields: [
                { label: "Organization Name", name: "organization_name", type: "text" },
                {
                    label: "Country of Organization Headquarters",
                    name: "country",
                    type: "select",
                    options: REGIONS
                },
                {
                    label: "Organization Type",
                    name: "organization_type",
                    type: "select",
                    options: ORG_TYPES
                },
                {
                    label: "Organization Sector",
                    name: "organization_sector",
                    type: "select",
                    options: SECTORS
                },
                {
                    label: "Organization History",
                    name: "organization_history",
                    type: "select",
                    options: HIST_DURATIONS
                },
                { label: "Organization Address", name: "organization_address", type: "text" },
                { label: "Organization Website", name: "organization_website", type: "text" },
                { label: "Organization Email", name: "organization_email", type: "email" },
                { label: "Contact Person Name", name: "contact_person_name", type: "text" },
                { label: "Contact Person Title", name: "contact_person_title", type: "text" },
                { label: "Contact Person Email", name: "contact_person_email", type: "email" },
                { label: "Contact Person Number", name: "contact_person_number", type: "number" }
            ]
        },
        { id: 4, role: "bot", text: "Do you have any current or previously developed framework related to digital intelligence?", options: ["Yes", "No"] },
        { id: 5, role: "bot", text: "Please submit the document that outlines the existing framework. We will run a DQ conformity test and display the results of what DQ Codes your framework currently aligns with.", type: "form",
            fields: [
                    { label: "Existing Framework", name: "file", type: "file_upload" },
            ]
        },
        { id: 6, role: "bot", text: "Which learner group are you targeting with this digital intelligence competency framework?", type: "form",
            fields: [
                { label: "Learner Group", name: "learnerGroup",  type: "select",  options: PROGRAM_TARGETS },
            ]
        },
        { id: 7, role: "bot", text: "Specify: What targeted audience age range?", type: "form",
            fields: [
                { label: "Learner Age", name: "learnerAge",  type: "select",  options: TARGET_AGE },
            ]
        },
        { id: 8, role: "bot", text: "What is the primary goal of building this competency framework? Example: We aim to develop students who are ethical digital citizens.", type: "form",
            fields: [
                { label: "Primary Goal", name: "Goal",  type: "text" },
            ]
        },


    ];

    const [chats, setChats] = useState([dummyChat[0]]);
    const [userInputs, setUserInputs] = useState({});

    const options = {};
    const data = { chats };
    const actions = {
        optionClickAction: (option) => {
            setChats((prevChats) => {
                const newChats = [...prevChats, {
                    role: "user",
                    text: option,
                    isSingleResponse: true
                }];

                const lastBotQuestion = prevChats[prevChats.length - 1];
                let nextQuestionIndex = dummyChat.findIndex(q => q.text === lastBotQuestion.text) + 1;

                if (lastBotQuestion.id === 4 && option === "No") {
                    nextQuestionIndex = dummyChat.findIndex(q => q.id === 6);
                }

                if (dummyChat[nextQuestionIndex]) {
                    return [...newChats, dummyChat[nextQuestionIndex]];
                }
                return newChats;
            });
        },


        inputSubmitAction: (formData) => {
            setUserInputs((prevInputs) => ({ ...prevInputs, ...formData }));

            setChats((prevChats) => {
                const newChats = [...prevChats];
                const lastBotQuestion = prevChats[prevChats.length - 1];
                const isMultiFieldForm = lastBotQuestion.fields?.length > 1;

                if (isMultiFieldForm) {
                    const formattedResponse = Object.entries(formData)
                        .map(([key, value]) => {
                            const field = lastBotQuestion.fields?.find(f => f.name === key);
                            return field ? `${field.label}: ${value}` : null;
                        })
                        .filter(Boolean)
                        .join('\n');

                    newChats.push({
                        role: "user",
                        text: formattedResponse,
                        isFormResponse: true
                    });
                } else {
                    Object.entries(formData).forEach(([key, value]) => {
                        const field = lastBotQuestion.fields?.find(f => f.name === key);
                        if (field) {
                            newChats.push({
                                role: "user",
                                text: `${field.label}: ${value}`,
                                isSingleResponse: true
                            });
                        }
                    });
                }

                let nextQuestionIndex = dummyChat.findIndex(q => q.text === lastBotQuestion.text) + 1;
                if (dummyChat[nextQuestionIndex]) {
                    newChats.push(dummyChat[nextQuestionIndex]);
                }

                return newChats;
            });
        },

        restartChatFromIndexAction: (index) => {
            setChats((prevChats) => {
                const updatedChats = prevChats.slice(0, index);

                // Find the last bot message with options
                let botMessageIndex = updatedChats.length - 1;
                while (botMessageIndex >= 0 && (updatedChats[botMessageIndex].role !== "bot" || !updatedChats[botMessageIndex].options)) {
                    botMessageIndex--;
                }

                if (botMessageIndex >= 0) {
                    // Restore the bot message with options
                    const botMessage = dummyChat.find(q => q.text === updatedChats[botMessageIndex].text);
                    if (botMessage) {
                        updatedChats[botMessageIndex] = { ...botMessage }; // Reassign original bot message
                    }
                }

                return updatedChats;
            });
        },

        fileUploadAction: (file) => {
            if (!file) return;

            setChats((prevChats) => {
                const newChats = [...prevChats, {
                    role: "user",
                    text: `Uploaded: ${file.name}`,
                    isSingleResponse: true
                }];
                const lastBotQuestion = prevChats[prevChats.length - 1];
                const nextQuestionIndex = dummyChat.findIndex(q => q.text === lastBotQuestion.text) + 1;

                if (dummyChat[nextQuestionIndex]) {
                    return [...newChats, dummyChat[nextQuestionIndex]];
                }
                return newChats;
            });
        },

    };

    return (
        <div>
            <FrameworkCreationView
                data={data}
                actions={actions}
                options={options}
            />
        </div>
    );
};

export default FrameworkCreationPage;